import {ActionTree} from 'vuex';
import { WidgetState } from "@/apps/MyStudyChoiceFavoritesWidget/models/store-viewmodel";
import services from "@/apps/MyStudyChoiceFavoritesWidget/services";
import { AxiosResponse } from "axios";

export default <ActionTree<WidgetState, any>>{
    loadMyStudyChoiceStudies(context) {
        context.commit('setInnerLoading', true)
        let config = context.getters.config

        services.myStudyChoice.getAllStudiesWithFavorites(config.language)
            .then((response: AxiosResponse) => {
                context.commit('setStudies', response.data)
            })
            .catch(() => {
                context.commit('root/setErrors', ['Something went wrong retrieving your studychoice activities'])
                context.commit('setInnerLoading', false)
            })
            .finally(() => {
                context.commit('setInnerLoading', false)
            })
    },
    deleteStudyChoiceFavorite(context, payload) {
        let favoriteId = payload
        context.commit('setInnerLoading', true)

        services.myStudyChoice.deleteFavourite(favoriteId)
            .then(() => {
                context.commit('removeFavoriteStudyFromFavoriteStudies', favoriteId)
            })
            .catch(() => {
                context.commit('root/setErrors', ['Something went wrong retrieving your favorite studies'])
                context.commit('setInnerLoading', false)
            })
            .finally(() => {
                context.commit('setInnerLoading', false)
            })
    },
    addStudyChoiceFavorite(context, payload) {
        let config = context.getters.config
        let study_code = payload

        services.myStudyChoice.setFavourite(config.language, study_code)
            .then((response: AxiosResponse) => {
                if (response.data && response.data.id) {
                    let payload = { 'studyCode': study_code, id: response.data.id }
                    context.commit('addFavoriteStudyToFavoriteStudies', payload)
                }
            })
            .catch(() => {
                context.commit('root/setErrors', ['Something went wrong retrieving your favorite studies'])
            })
            .finally(() => {
            })
    },
    setStudySearchModal(context, payload) {
        context.dispatch('loadMyStudyChoiceStudies')
        context.commit('setStudySearchModal', payload)
    },
    setConfig(context, payload) {
        context.commit('setConfig', payload)
    },
    setSearchQuery(context, payload) {
        context.commit('setSearchQuery', payload)
    }
}
